import { MapPin } from 'lucide-react';
import { cn } from '@/lib/utils';

export function GeofenceIndicator({ siteLocation, className }) {
  if (!siteLocation?.geofence_enabled) return null;

  const radiusMeters = siteLocation.geofence_radius || 100;

  return (
    <div
      className={cn(
        'inline-flex items-center gap-2 rounded-xl border border-amber-200 bg-amber-50 px-3 py-1.5',
        className
      )}
    >
      <MapPin className="h-3.5 w-3.5 text-amber-600" />
      <span className="text-xs font-medium text-amber-800">Geofence Active</span>
      <span className="text-[10px] text-amber-600">{radiusMeters}m</span>
    </div>
  );
}
